import { AsyncPipe } from '@angular/common';
import { Component, inject } from '@angular/core';

import { ConfigService } from '@app-core/services';

@Component({
  selector: 'app-loader',
  templateUrl: './loader.component.html',
  styleUrls: ['./loader.component.scss'],
  imports: [AsyncPipe],
})
export class LoaderComponent {
  private _configService = inject(ConfigService);

  loading$ = this._configService.loading$;
}
